import { FC } from 'react';
import { startCase } from 'lodash';

import { Counter } from '@/components';
import { NOT_DEFINED } from '@/constants';

import {
  ProductActionFavorite,
  ProductBadgeContainer,
  ProductCategory,
  ProductImage,
  ProductInfo,
  ProductLinkWrapper,
  ProductName,
  ProductPrice,
  ProductVariants,
} from '../Product.components';
import { ProductVariationProps } from '../Product';
import { useProductContext } from '../context';

import classNames from 'classnames';

import style from '../product.module.scss';
import styleVariation from './ProductCardWithHighlighted.module.scss';

const ProductCardWithHighlighted: FC<ProductVariationProps> = ({
  className,
  analyticsListName,
  isLargeCard,
  onKiosk,
  isAddToCartInKioskDisabled,
  onKioskAddClicked,
}) => {
  const { product, isSpecial, weightVariant, variants } = useProductContext();

  return (
    <div
      className={classNames(style.product, styleVariation.product, className)}
    >
      <ProductLinkWrapper
        analyticsListName={analyticsListName}
        isInternalWrapper
        onKiosk={onKiosk}
        product={product}
      >
        <div className={styleVariation.product__image_container}>
          <ProductImage
            className={styleVariation.product__image}
            product={product}
          />
          <div
            aria-label="Product actions"
            className={styleVariation.actions__body}
            role="group"
          >
            <ProductActionFavorite
              className={classNames(style.favorite_action)}
              product={product}
            />
          </div>
        </div>
        <div
          className={classNames(
            style.product__body,
            styleVariation.product__body,
          )}
        >
          <ProductBadgeContainer
            className={styleVariation.product_badge__container}
            key="badge-container"
            onKiosk={onKiosk}
            product={product}
            weightVariant={weightVariant}
          />
          <ProductName name={product?.name || NOT_DEFINED} />
          <div
            aria-label={`Product category and type: ${startCase(
              product?.subcategory || NOT_DEFINED,
            )}${product?.flower_type ? `, ${product.flower_type}` : ''}`}
            className={classNames(
              style.info__brand_category,
              styleVariation.info__brand_category,
            )}
            role="group"
          >
            <ProductInfo
              className={style.category}
              info={startCase(product?.subcategory || NOT_DEFINED)}
              label="Category"
              type="default"
            />
            <ProductCategory
              className={style.product__only_category}
              info={product?.flower_type as string}
              type="default"
            />
          </div>
          <ProductPrice
            className={styleVariation.product__price_container}
            elementVariants={<ProductVariants />}
            isOverflow={variants?.length === 1}
            isSpecial={isSpecial}
            type="expanded-tax"
            weightVariant={weightVariant}
          />
        </div>

        {onKiosk && isAddToCartInKioskDisabled ? null : (
          <div
            className={classNames(
              style.product__actions_footer_button,
              styleVariation.product__actions_footer_button,
              {
                [style.product__actions_footer_button_disabled]:
                  product?.isLowStock,
                [style.product__actions_footer_button_large_card]: isLargeCard,
              },
            )}
          >
            <Counter
              actionTheme="link"
              className={classNames(style.actions__counter_button, {
                [style.actions__counter_button_large_card]: isLargeCard,
              })}
              classNameCounter={style.actions__counter_button_form}
              onCard
              onKiosk={onKiosk}
              onKioskAddClicked={onKioskAddClicked}
              product={product}
              selectedWeightVariant={weightVariant}
              showIcon
            />
          </div>
        )}
      </ProductLinkWrapper>
    </div>
  );
};

export { ProductCardWithHighlighted };
